import { useState } from "react";
import noimage from "../../../../../assets/Images/laundrynoimage.jpg";

export const useImageFallback = (src?: string) => {
  const [imgSrc, setImgSrc] = useState(src || noimage);

  const handleError = () => {
    setImgSrc(noimage);
  };

  return { imgSrc, handleError };
};
